module.exports = __webpack_public_path__ + "static/media/shop-card-placeholder.03b37cc2.jpg";